<script lang="ts" setup>
import { useSeoMeta } from '@unhead/vue';

import {
    WebAnimator,
    WebPage,
    WebTrainingScreenshot,
} from '@/components';

import {
    GetStarted,
    Hero,
    Testimonials,
} from "@/components/panels/index";


useSeoMeta({
  title: 'Teams work better with Backstage',
  description: 'Effective soft skills training for any team on any budget. No contracts. No subscriptions. Just pay for the training you actually use.',
  ogDescription: 'Effective soft skills training for any team on any budget. No contracts. No subscriptions. Just pay for the training you actually use.',
  ogTitle: 'Teams work better with Backstage',
});
</script>

<template>
    <WebPage>
        <Hero>
            <template #title>
                 <WebAnimator animation=text duration=250 delay=0 display=inline-block :wait-for-seen=false>
                    <span>Teams</span>
                </WebAnimator> <WebAnimator animation=text duration=250 delay=125 display=inline-block :wait-for-seen=false>
                    <span>Work</span>
                </WebAnimator> <WebAnimator animation=text duration=250 delay=250 display=inline-block :wait-for-seen=false>
                    <span>Better</span>
                </WebAnimator> <WebAnimator animation=text duration=250 delay=375 display=inline-block :wait-for-seen=false>
                    <span>with</span>
                </WebAnimator> <WebAnimator animation=text duration=250 delay=500 display=inline-block :wait-for-seen=false>
                    <span class="text-gradient">Backstage</span>
                </WebAnimator>
            </template>
            <template #subtitle>
                <WebAnimator animation=text duration=250 delay=750 display=block :wait-for-seen=false>
                    <span>
                        Effective soft skills training for
                        <span class="text-golden font-[500]">any team</span>
                        on
                        <span class="text-golden font-[500]">any budget</span>.
                        No contracts. No subscriptions. Just
                        <span class="text-golden font-[500]">pay for the training you actually use</span>.
                    </span>
                </WebAnimator>
            </template>
            <template #content>
                <WebAnimator animation=fade-in duration=250 delay=1000 :wait-for-seen=false display=flex>
                    <WebTrainingScreenshot :initial-delay=1000 :wait-for-seen=false />
                </WebAnimator>
            </template>
        </Hero>

        <Testimonials />

        <GetStarted />
    </WebPage>
</template>